import { colors } from '../../../common/ui/colors';

export const buttonShadows = {
    drop: '0px 1px 1px 0px rgba(25, 54, 67, 0.16)',
    borderHover: `0px 0px 0px 1px ${colors.foreground.disabled}`,
    dropHover: '0px 2px 4px 0px rgba(25, 54, 67, 0.08)',
    emphDrop: '0px 1px 1px 0px rgba(0, 0, 0, 0.12)',
    emphBorder: `0px 0px 0px 1px ${colors.accent.emphasis}`,
    emphBorderHover: `0px 0px 0px 1px ${colors.accent.foreground}`,
    emphBorderDisabled: '0px 0px 0px 1px rgba(115, 167, 255, 0.66)',
    destructiveBorder: `0px 0px 0px 1px ${colors.negative.emphasis}`,
    destructiveBorderHover: `0px 0px 0px 1px ${colors.negative.foreground}`,
    destructiveBorderDisabled: '0px 0px 0px 1px rgba(255, 123, 109, 0.66)',
};
